import { Chip as NChip, type ChipProps as NChipProps } from '@natera/material/lib/chip'
import { Icon } from '@natera/material/lib/icon'
import { cn } from '~/shared/lib/cn'
import { LocalIcon } from '../local-icon'
import './chip.scss'

interface ChipProps extends Omit<NChipProps, 'size'> {
  size?: 'xs' | 'sm' | 'md'
  onClose?: () => void
  dropdown?: boolean
  attention?: boolean
}

export function Chip({
  className,
  size = 'md',
  onClose,
  dropdown = false,
  attention = false,
  ...rest
}: ChipProps) {
  return (
    <NChip
      trailingIcon={
        onClose ? (
          <button
            type="button"
            tabIndex={0}
            className="group/btn inline-flex cursor-pointer items-center border-none bg-transparent p-0 outline-none"
            onClick={(event) => {
              if (rest.disabled) return
              event.stopPropagation()
              onClose()
            }}
            onKeyDown={(event) => {
              if (rest.disabled) return
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                event.stopPropagation()
                onClose()
              }
            }}
          >
            <Icon
              className={cn(
                'group-focus-visible/btn:text-primary-main hover:text-primary-main text-[18px]',
                {
                  'opacity-50': rest.disabled,
                },
              )}
              children="cancel"
              fill
            />
          </button>
        ) : dropdown ? (
          <LocalIcon
            className={cn('text-content-high-emphasis', {
              'opacity-50': rest.disabled,
            })}
            name="arrowDown"
            size="18"
          />
        ) : undefined
      }
      {...rest}
      className={cn(
        'c-chip',
        {
          'c-chip--xs': size === 'xs',
          'h-6': size === 'xs',
          'h-7': size === 'sm',
          'h-8': size === 'md',
          'c-chip--attention': attention,
        },
        className,
      )}
      tabIndex={-1}
    />
  )
}
